// extracted by mini-css-extract-plugin
export default {"familyHistoryForm":"FamilyHistory_familyHistoryForm__nINrs","fieldLabel":"FamilyHistory_fieldLabel__VyZ4q","requiredMark":"FamilyHistory_requiredMark__RVgTM"};